import { render, staticRenderFns } from "./ItserveButton.vue?vue&type=template&id=52052d64&scoped=true&"
import script from "./ItserveButton.vue?vue&type=script&lang=js&"
export * from "./ItserveButton.vue?vue&type=script&lang=js&"
import style0 from "./ItserveButton.vue?vue&type=style&index=0&id=52052d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52052d64",
  null
  
)

export default component.exports